import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import * as urls from '../../utilities/urls';
import { NzTableData } from '../../utilities/nz-table.adapter';
import { MerchantUserSearch} from '../../models/merchant-user';
import { AuthService } from '../../auth/auth.service';
import { NotificationSearch } from 'src/app/models/notification';


@Injectable({
    providedIn: 'root',
})
export class AccountMasterService {
    constructor(private httpClient: HttpClient, private router: Router, private authService: AuthService) {}

getUserInfo(tableData: NzTableData<MerchantUserSearch, any>) {
  const value = {
            id: tableData.search.id ? tableData.search.id : '',
            role: [tableData.search.userType],
            appCode: this.authService.getAppCode()
        };
  return this.httpClient.post(urls.AdminUserUrls.user + urls.AdminUserUrls.userList, value);
}
editUser(value) {
    return this.httpClient.post(urls.AdminUserUrls.user + urls.AdminUserUrls.editUser , value);
}
getAllLocations(value) {
    return this.httpClient.post(urls.LocationUrls.location + urls.LocationUrls.list, value);
}
getAllTerminals(value) {
    return this.httpClient.post(urls.TerminalUrls.terminal + urls.TerminalUrls.list , value);
}
// For List
getNotificationListWithLimit(tableData: NzTableData<NotificationSearch, any>) {
    const value = {
      userId:tableData.search.userId,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex
    };
     return this.httpClient.post(urls.NotificationUrls.notificationList, value);
  }
}
